export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const saveToFile = async (expenses, setSaveMsg) => {
  try {
    if ('showSaveFilePicker' in window) {
      const fileHandle = await window.showSaveFilePicker({
        suggestedName: `expenses-${new Date().toISOString().split('T')[0]}.json`,
        types: [{
          description: 'JSON files',
          accept: { 'application/json': ['.json'] },
        }],
      });
      const writable = await fileHandle.createWritable();
      await writable.write(JSON.stringify(expenses, null, 2));
      await writable.close();
      setSaveMsg("File saved to your computer!");
      setTimeout(() => setSaveMsg(null), 3000);
    } else {
      // Fallback to download for browsers without File System Access API
      const dataStr = JSON.stringify(expenses, null, 2);
      const dataBlob = new Blob([dataStr], { type: 'application/json' });
      downloadBlob(dataBlob, `expenses-${new Date().toISOString().split('T')[0]}.json`);
      setSaveMsg("File downloaded!");
      setTimeout(() => setSaveMsg(null), 3000);
    }
  } catch (err) {
    if (err.name !== 'AbortError') {
      console.error('Save failed:', err);
      setSaveMsg("Save failed!");
      setTimeout(() => setSaveMsg(null), 3000);
    }
  }
};

export const loadFromFile = async (setExpenses, setSaveMsg) => {
  return new Promise((resolve, reject) => {
    try {
      if ('showOpenFilePicker' in window) {
        window.showOpenFilePicker({
          types: [{
            description: 'JSON files',
            accept: { 'application/json': ['.json'] },
          }],
        }).then(async ([fileHandle]) => {
          try {
            const file = await fileHandle.getFile();
            const contents = await file.text();
            const loadedExpenses = JSON.parse(contents);
            if (Array.isArray(loadedExpenses)) {
              setExpenses(loadedExpenses);
              setSaveMsg("File loaded successfully!");
              setTimeout(() => setSaveMsg(null), 3000);
              resolve();
            } else {
              setSaveMsg("Invalid file format!");
              setTimeout(() => setSaveMsg(null), 3000);
              reject(new Error("Invalid file format"));
            }
          } catch (err) {
            console.error('Load failed:', err);
            setSaveMsg("Load failed!");
            setTimeout(() => setSaveMsg(null), 3000);
            reject(err);
          }
        }).catch(reject);
      } else {
        // Fallback to file input for browsers without File System Access API
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json';
        input.onchange = async (e) => {
          const file = e.target.files[0];
          if (file) {
            try {
              const contents = await file.text();
              const loadedExpenses = JSON.parse(contents);
              if (Array.isArray(loadedExpenses)) {
                setExpenses(loadedExpenses);
                setSaveMsg("File loaded successfully!");
                setTimeout(() => setSaveMsg(null), 3000);
                resolve();
              } else {
                setSaveMsg("Invalid file format!");
                setTimeout(() => setSaveMsg(null), 3000);
                reject(new Error("Invalid file format"));
              }
            } catch (err) {
              console.error('Load failed:', err);
              setSaveMsg("Load failed!");
              setTimeout(() => setSaveMsg(null), 3000);
              reject(err);
            }
          }
        };
        input.click();
      }
    } catch (err) {
      console.error('Load failed:', err);
      setSaveMsg("Load failed!");
      setTimeout(() => setSaveMsg(null), 3000);
      reject(err);
    }
  });
};
